import { createReducer, on } from '@ngrx/store';
import { login, loginFailed, loginSuccessful, userNotActivated} from './auth.actions';
import { AdminCountry, AuthUser, CompanyProfile } from './auth.interface';
import * as authActions from './auth.actions'

export interface AuthState {
    // authUser : AuthUser | null
    isLoggedIn: boolean;
    loginLoading: boolean;
    mfaLoading: boolean;

    isInactiveError: boolean;

    isCustomerLoggedIn: boolean;
    customerLoginLoading: boolean;
    // countries: AdminCountry[];
    // adminCountry: AdminCountry | null;
    entityTypes,
    entityTypesLoading: boolean
    entityTypesError: boolean

    businessTypes,
    businessTypesLoading: boolean
    businessTypesError: boolean

    transactionsTypes,
    transactionsTypesLoading: boolean
    transactionsTypesError: boolean

    companyProfile: CompanyProfile | null
    companyProfileLoading: boolean
    companyProfileError: boolean
    
}

export const initialState: AuthState = {
    // authUser : null,
    isLoggedIn: false,
    loginLoading: false,
    mfaLoading: false,
    isInactiveError: false,

    isCustomerLoggedIn:false,
    customerLoginLoading:false,
    // countries: [],
    // adminCountry: null
    entityTypes : null,
    entityTypesLoading: null,
    entityTypesError: null,

    businessTypes : null,
    businessTypesLoading: null,
    businessTypesError: null,

    transactionsTypes : null,
    transactionsTypesLoading: null,
    transactionsTypesError: null,

    companyProfile:  null,
    companyProfileLoading: null,
    companyProfileError: null,
}

export const authReducer = createReducer(
    initialState,

    on(login, (state) => ({
        ...state, loginLoading: true
    })),

    on(loginSuccessful, (state) => ({
        ...state, loginLoading: false, isLoggedIn: true
    })),

    on(loginFailed, (state) => ({
        ...state, loginLoading: false
    })),

    on(userNotActivated, (state) => ({
        ...state,isInactiveError: true,
    })),

    // on(setAuthUser, (state, { authUser }) => ({
    //     ...state, authUser : authUser  
    // })),

    // on(setAdminCountry, (state, { adminCountry }) => ({
    //     ...state, adminCountry
    // })),

    // on(setCountries, (state, { countries }) => ({
    //     ...state, countries
    // }))

    on(authActions.fetchEntityTypes, (state) => ({
        ...state, entityTypes: null, entityTypesError: null, entityTypesLoading: true
    })),

    on(authActions.fetchEntityTypesSuccess, (state, {entityTypes}) => ({
        ...state, entityTypes: entityTypes, entityTypesError: false, entityTypesLoading: false
    })),

    on(authActions.fetchEntityTypesFailed, (state) => ({
        ...state, entityTypes: null, entityTypesError: true, entityTypesLoading: false
    })),


    on(authActions.fetchBusinessTypes, (state) => ({
        ...state, businessTypes: null, businessTypesError: null, businessTypesLoading: true
    })),

    on(authActions.fetchBusinessTypesSuccess, (state, {businessTypes}) => ({
        ...state, businessTypes: businessTypes, businessTypesError: false, businessTypesLoading: false
    })),

    on(authActions.fetchBusinessTypesFailed, (state) => ({
        ...state, businessTypes: null, businessTypesError: true, businessTypesLoading: false
    })),



    on(authActions.fetchTransactionTypes, (state) => ({
        ...state, transactionsTypes: null, transactionsTypesError: null, transactionsTypesLoading: true
    })),

    on(authActions.fetchTransactionTypesSuccess, (state, {transactionTypes}) => ({
        ...state, transactionsTypes: transactionTypes, transactionsTypesError: false, transactionsTypesLoading: false
    })),

    on(authActions.fetchTransactionTypesFailed, (state) => ({
        ...state, transactionsTypes: null, transactionsTypesError: true, transactionsTypesLoading: false
    })),


    on(authActions.fetchCompanyProfile, (state) => ({
        ...state, companyProfile: null, companyProfileError: null, companyProfileLoading: true
    })),

    on(authActions.fetchCompanyProfileSuccess, (state, {companyProfile}) => ({
        ...state, companyProfile: companyProfile, companyProfileError: false, companyProfileLoading: false
    })),

    on(authActions.fetchCompanyProfileFailed, (state) => ({
        ...state, companyProfile: null, companyProfileError: true, companyProfileLoading: false
    })),

    on(authActions.mfaPending, (state) => ({
        ...state, loginLoading: false
    })),

    on(authActions.verifyMfa, (state) => ({
        ...state, mfaLoading: true
    })),

    on(authActions.verifyMfaSuccess, (state) => ({
        ...state, mfaLoading: false, isLoggedIn: true
    })),

    on(authActions.verifyMfaFailed, (state) => ({
        ...state, mfaLoading: false
    })),
);